export default __webpack_public_path__ + "static/media/defient_image2-mobile.png.webp";